// import store from 'store';
import { makeRequest } from 'utils/requestLogger';

// forgotPassword.js is for telling backend to send an email to reset pwd
// newPassword.js is for setting a password if you have forgotten your previous pwd
//  using the link that is emailed to you after forgotPassword
// changePassword.js is for changing password after logging in
export default (payload) =>
  makeRequest('put', `/api/users/${payload.id}/password`, payload);



// WEBPACK FOOTER //
// ./src/app/services/account/changePassword.js